import React from 'react';
import { Link } from 'react-router-dom';

export function SessionPlanCard({ plano, onAprovar, onTrocar, onAdiar, onAjustar, onRejeitar, onAplicar, onRegistrar }) {
  if (!plano) return null;

  return (
    <article className="session-plan-card" data-status={plano.status}>
      <header className="session-plan-card__header">
        <div><p className="session-plan-card__eyebrow">Plano sugerido</p><h3>{plano.alunoNome || plano.alunoId}</h3><p>{plano.objetivoSessao}</p></div>
        <strong>{plano.duracaoTotalMin} min</strong>
      </header>

      <ol className="session-plan-card__items">
        {plano.itens?.map((item) => (
          <li key={`${plano.id}-${item.ordem}-${item.atividadeId}-${item.comboKey || ''}`}>
            <div>
              <strong>{item.instancia?.titulo || item.tituloSnapshot}</strong>
              <span>{item.tipo} · nível {item.nivelSugerido} · {item.duracaoMin} min</span>
            </div>
            {item.instancia ? <p><b>Variação:</b> {item.instancia.contexto} · {item.instancia.material} · apoio {item.instancia.apoio}</p> : null}
            <p>{item.motivo}</p>
            {item.instancia?.roteiro?.length ? <details><summary>Roteiro rápido</summary><ol>{item.instancia.roteiro.map((step) => <li key={step.passo}>{step.acao}</li>)}</ol></details> : null}
            <div className="session-plan-card__item-actions">
              <button type="button" onClick={() => onTrocar?.(plano, item)}>Trocar variação</button>
              <button type="button" onClick={() => onAdiar?.(plano, item)}>Adiar</button>
              <button type="button" onClick={() => onAjustar?.(plano, item)}>Ajustar</button>
            </div>
          </li>
        ))}
      </ol>

      <footer className="session-plan-card__actions">
        <Link className="session-plan-card__pei-link" to={`/aluno/${encodeURIComponent(plano.alunoId)}/pei-smart`}>PEI inteligente</Link>
        {plano.status === 'proposto' || plano.status === 'ajustado' ? <><button type="button" className="primary" onClick={() => onAprovar?.(plano)}>Aprovar</button><button type="button" onClick={() => onRejeitar?.(plano)}>Rejeitar e regenerar</button></> : null}
        {plano.status === 'aprovado' ? <button type="button" className="primary" onClick={() => onAplicar?.(plano)}>Marcar como aplicado</button> : null}
        {plano.status === 'aplicado' ? <button type="button" className="primary" onClick={() => onRegistrar?.(plano)}>Registrar resultado</button> : null}
        {plano.status === 'registrado' ? <button type="button" onClick={() => onRegistrar?.(plano)}>Atualizar detalhes</button> : null}
      </footer>
    </article>
  );
}

export default SessionPlanCard;
